// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck
import Link from 'next/link';
import BlockContent from '@sanity/block-content-to-react';
import { Box, Flex, Icon, Link as ChakraLink, Text } from '@chakra-ui/react';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  ExclamationIcon
} from '@heroicons/react/solid';
import { ExternalLinkIcon } from '@components';
import { useRouter } from 'next/router';

const serializers = {
  types: {
    block: ({ children }) => {
      return <Text textStyle="sm-normal">{children}</Text>;
    }
  },

  marks: {
    fragmentId: ({ mark, children }) => {
      const { hash } = mark;
      return <span id={hash}>{children}</span>;
    },
    internalLink: ({ mark, children }) => {
      const { hash, slug = {} } = mark;
      const href = slug?.current;

      if (hash) {
        return <a href={`${href || ''}#${hash}`}>{children}</a>;
      }

      if (href) {
        return (
          <Link legacyBehavior href={href} passHref>
            <ChakraLink fontWeight="medium">{children}</ChakraLink>
          </Link>
        );
      }

      return <span>{children}</span>;
    },
    link: ({ mark, children }) => {
      const { blank, href } = mark;

      if (href) {
        return blank ? (
          <ChakraLink href={href} isExternal fontWeight="medium">
            {children}

            <Icon
              as={ExternalLinkIcon}
              pos="relative"
              top={-0.5}
              ml={0.5}
              boxSize={5}
            />
          </ChakraLink>
        ) : (
          <ChakraLink href={href} fontWeight="medium">
            {children}
          </ChakraLink>
        );
      }

      return <span>{children}</span>;
    }
  }
};

type Props = {
  type: 'Danger' | 'Info' | 'Success' | 'Warning';
  body: any; // TODO: remove `any`
};

export function Callout({ type, body }: Props) {
  const { route } = useRouter();

  const secondaryBlue = route.includes('/docs/')
    ? `var(--secondaryBlue)`
    : 'primary.500';

  const backgroundColor = route.includes('/docs/')
    ? 'var(--highlightBg)'
    : 'gray.50';

  const iconSwitch = () => {
    switch (type) {
      case 'Danger':
        return { icon: ExclamationCircleIcon, color: '#FF8F8F' };
      case 'Warning':
        return { icon: ExclamationIcon, color: 'yellow.500' };
      case 'Success':
        return { icon: CheckCircleIcon, color: '#BEF972' };
      case 'Info':
        return { icon: InformationCircleIcon, color: secondaryBlue };
      default:
        return { icon: InformationCircleIcon, color: secondaryBlue };
    }
  };

  const borderSwitch = () => {
    switch (type) {
      case 'Danger':
        return { color: '#FF8F8F' };
      case 'Warning':
        return { color: 'yellow.500' };
      case 'Success':
        return { color: '#BEF972' };
      case 'Info':
        return { color: secondaryBlue };
      default:
        return { color: secondaryBlue };
    }
  };

  const { icon, color: iconColor } = iconSwitch();
  const { color: borderColor } = borderSwitch();

  return (
    <Flex
      justify="center"
      align="center"
      px={6}
      py={4}
      my={6}
      bg={backgroundColor}
      gap={2}
      rounded="md"
      borderLeft="solid 4px"
      borderColor={borderColor}
    >
      <Icon as={icon} color={iconColor} boxSize={5} pos="relative" />
      <Box w="full">
        <BlockContent blocks={body} serializers={serializers} />
      </Box>
    </Flex>
  );
}
